import { useParams } from "react-router-dom";

/**
 * Read the expected URL params for the Aphrodite Work application.
 */
export function useAppParams(): {
  tenant: string;
  assessmentId: string;
  workId: string;
} {
  const params = useParams<"workId" | "tenant" | "assessmentId">();

  if (!params.tenant || !params.assessmentId || !params.workId) {
    throw new Error("Missing required URL params");
  }

  return {
    tenant: params.tenant,
    assessmentId: params.assessmentId,
    workId: params.workId,
  };
}
